import _ from 'lodash';
import { authenticationError, authenticationSuccess } from 'src/redux/authentication/authentication-actions';
import { QueryParameters, apiService, urlService } from 'src/services';

interface OidcUserProfile {
	sid: string;
	sub: string;
	authTime: Date | undefined;
	username: string;
	givenName: string;
	familyName: string;
	email: string;
	activeTenantId: string;
	tenantCode: string;
	products: string[];
	role: string[];
}

interface OidcUser {
	idToken: string;
	sessionState: string;
	accessToken: string;
	tokenType: string;
	scope: string;
	profile: OidcUserProfile;
	expiresAt: Date | undefined;
}

const parseDate = (timestampInSecond: number | undefined) => {
	if (timestampInSecond && !isNaN(timestampInSecond)) {
		return new Date(timestampInSecond * 1000);
	}
};

export const saveOidcUser = (user: any) => async (dispatch: any) => {
	//Example of raw OIDC data from AQI Identity Server:
	//{"id_token":"eyJhbGciOiJSUzI1NiIsImtpZCI6IjgwRkIwOTM4NTdCM0JGOTAwQkYwN0MzRTMyMDY4MjNGODIwMjE2MzQiLCJ0eXAiOiJKV1QiLCJ4NXQiOiJnUHNKT0ZlenY1QUw4SHctTWdhQ1A0SUNGalEifQ.eyJuYmYiOjE2Mzk1MDIyNzQsImV4cCI6MTYzOTU4ODY3NCwiaXNzIjoiaHR0cHM6Ly9hcGktZmVhdHVyZS11cy5hcXVhdGljaW5mb3JtYXRpY3MubmV0IiwiYXVkIjoiQUNQLkF1dGhDb2RlIiwiaWF0IjoxNjM5NTAyMjc0LCJhdF9oYXNoIjoia2FpTUphSkQ0WS1pWXFBc040andpQSIsInNpZCI6IjI2MTEyM2U1NjJjZWU3ZWRlMmY1NDgxMzUxZGU4OTZmIiwic3ViIjoiMjZiNzM3NTMtYzAwNC00YTM3LWE5ZDEtMmM1YWE1ZDM0NTA5IiwiYXV0aF90aW1lIjoxNjM5NTAyMjY1LCJpZHAiOiJsb2NhbCIsIlVzZXJSb2xlcyI6IltcImQ5OGMwYjZmLTJhOTctNGVkMS1hMjM1LTdmYjU1NjIzYzJkMFwiLFwiYmJjZDIzMTktM2M1Ni00NTExLWJiZWYtZjJkMmQ4NzA3NzQ4XCJdIiwidXNlcl9uYW1lIjoiYWNwZGV2IiwiZ2l2ZW5fbmFtZSI6IkRldiIsImZhbWlseV9uYW1lIjoiQUNQRGV2IiwiZW1haWwiOiJsaW5rb2RldkBhcXVhdGljaW5mb3JtYXRpY3MuY29tIiwiQWN0aXZlVGVuYW50SWQiOiI5YWE2MWM0NS0zMTY1LTQyODItYmZmYS03MWVlMGMyOTVkMmYiLCJ0ZW5hbnRfbm9kZSI6Ii8xLzQvNi8iLCJwcm9kdWN0cyI6WyJjMjljNDc0Ni1kODg0LTQ5N2YtOWY2ZC0yMzMzZWViOWZlMGQiLCIzYTA5NDliMS0yMDU2LTRjOWYtYWRlOC1hNmQ5NTRlYzI1ZmYiLCI4YTcwODI0YS1hNmE3LTQwZGEtOWMyYS00Y2FmMDhlZjVkMDUiXSwicm9sZSI6WyJkOThjMGI2Zi0yYTk3LTRlZDEtYTIzNS03ZmI1NTYyM2MyZDAiLCJiYmNkMjMxOS0zYzU2LTQ1MTEtYmJlZi1mMmQyZDg3MDc3NDgiXSwiYW1yIjpbInB3ZCJdfQ.FhRFdCl2dL623LGLeUnECKp7kl-qewvXTtx4i6h2yh6Ra_ISmmUUbk9ZMmKZk7nb17glUsqBK_ogIMoX3IjRAdrYxJhpBZOKytG4TjwPnOBX4A00DUqU9oSudpqm-7NRfsFPmSK2cpJRYxG1-fCvjX5VSsNeefiAWE4d5Wglr_vh8-yyg2iNum2W5upgBS2rMr_cUfZAAI9AyXSBVBfwt26qJpyM5rr5e57gQ4iwUiljxvaWa_SmYukcrNZbQMcOxvYQX5AjSQifuLe0D0HBZ6zeO1SUCO5mwOqjF74_S4auk__rJZC3n76SxDRZ0fWhQ9AsNardVcwIQU-s0ERa4Q","session_state":"AOQR0SQcEhs-_pcCMIM3y61eBQyvp7fCOwXTxKUSPwI.f55d20cf5409110e43e862536f1a3ddf",	"access_token": "3414afc26347ba179c01cc5b4542205f71f6a06da708a1ed2f86ffe2c97e8091", "token_type": "Bearer", "scope": "openid email FFAccessAPI", "profile": { "sid": "261123e562cee7ede2f5481351de896f", "sub": "26b73753-c004-4a37-a9d1-2c5aa5d34509", "auth_time": 1639502265, "idp": "local",	"UserRoles": "[\"d98c0b6f-2a97-4ed1-a235-7fb55623c2d0\",\"bbcd2319-3c56-4511-bbef-f2d2d8707748\"]", "user_name": "acpdev", "given_name": "Dev", "family_name": "ACPDev", "email": "linkodev@aquaticinformatics.com", "ActiveTenantId": "9aa61c45-3165-4282-bffa-71ee0c295d2f", "tenant_node": "/1/4/6/", "products": ["c29c4746-d884-497f-9f6d-2333eeb9fe0d", "3a0949b1-2056-4c9f-ade8-a6d954ec25ff", "8a70824a-a6a7-40da-9c2a-4caf08ef5d05"], "role": ["d98c0b6f-2a97-4ed1-a235-7fb55623c2d0", "bbcd2319-3c56-4511-bbef-f2d2d8707748"], "amr": ["pwd"] }, "expires_at": 1639588669
	let profile = _.get(user, 'profile');
	let oidcUserProfile: OidcUserProfile = {
		sid: _.get(profile, 'sid', ''),
		sub: _.get(profile, 'sub', ''),
		authTime: parseDate(_.get(profile, 'auth_time')),
		username: _.get(profile, 'user_name', ''),
		givenName: _.get(profile, 'given_name', ''),
		familyName: _.get(profile, 'family_name', ''),
		email: _.get(profile, 'email', ''),
		activeTenantId: _.get(profile, 'sub', ''),
		tenantCode: _.get(profile, 'sub', ''),
		products: _.get(profile, 'products', []),
		role: _.get(profile, 'role', [])
	};
	let oidcUser: OidcUser = {
		idToken: _.get(user, 'id_token', ''),
		sessionState: _.get(user, 'session_state', ''),
		accessToken: _.get(user, 'access_token', ''),
		tokenType: _.get(user, 'token_type', ''),
		scope: _.get(user, 'scope', ''),
		profile: oidcUserProfile,
		expiresAt: parseDate(_.get(user, 'expires_at'))
	};
	const oidcSignInCallbackUrl = `${urlService.getApiBaseUrl()}/Account/AqiOidcCallback`;
	apiService
		.httpPost(oidcSignInCallbackUrl, oidcUser)
		.then(signInResult => {
			dispatch(authenticationSuccess(signInResult));
		})
		.catch(error => {
			dispatch(authenticationError(error));
		});
};

export const landingAqiUser = (accessToken: string, email: string, expiresAt: string, idToken: string) => async (
	dispatch: any
) => {
	let queryParams = new QueryParameters()
		.add('accessToken', accessToken)
		.add('idToken', idToken)
		.add('email', email)
		.add('expiresAt', expiresAt);
	const oidcSignInLandingUrl = `${urlService.getApiBaseUrl()}/Account/AqiOidcLanding?${queryParams.toQueryString()}`;
	apiService
		.httpGet(oidcSignInLandingUrl)
		.then(signInResult => {
			dispatch(authenticationSuccess(signInResult));
		})
		.catch(error => {
			dispatch(authenticationError(error));
		});
};
